import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return setError("Password must be at least 8 characters.");
    if (password !== confirm) return setError("Passwords do not match.");
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Choose a new password" subtitle="Enter a new password for your account."
      footer={<Link to="/login" className="font-semibold text-slate-900 underline">Back to sign in</Link>}>
      {!token ? (
        <p className="text-sm text-red-600" data-testid="reset-no-token">This reset link is missing its token. Please request a new link.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div>
            <Label htmlFor="password">New password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              data-testid="reset-password-input" className="mt-1.5" placeholder="••••••••" />
          </div>
          <div>
            <Label htmlFor="confirm">Confirm new password</Label>
            <Input id="confirm" type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)}
              data-testid="reset-confirm-input" className="mt-1.5" placeholder="••••••••" />
          </div>
          {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
          <Button type="submit" disabled={loading} data-testid="reset-submit-btn" className="w-full bg-slate-900 hover:bg-slate-800">
            {loading ? "Saving…" : "Reset password"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
